/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
:host .container, :host .item-content, :host .content {
  min-block-size: 3rem;
}

:host([layout=vertical]) {
  inline-size: 100%;
}

:host(:not([layout=vertical])) {
  block-size: 100%;
}

.container,
.item-content {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex-direction: row;
  align-items: stretch;
}

.content {
  position: relative;
  box-sizing: border-box;
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: var(--calcite-color-foreground-1);
  padding-inline: 1rem;
  font-size: var(--calcite-font-size-0);
  color: var(--calcite-color-text-2);
  outline: 2px solid transparent;
  outline-offset: 2px;
  text-decoration: none;
  border-block-end: 0.125rem solid transparent;
  padding-block-start: 0.125rem;
}
.content:hover {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-2);
}
.content:focus {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-2);
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.content:active {
  background-color: var(--calcite-color-foreground-3);
  color: var(--calcite-color-text-1);
}
.content span {
  display: inline-flex;
}
.content.layout--vertical {
  display: flex;
  inline-size: 100%;
  justify-content: flex-start;
  padding-block: 1rem;
  border-block-end: 0;
  border-inline-end: 0.25rem solid transparent;
}

:host([active]) .content {
  color: var(--calcite-color-text-1);
  border-color: var(--calcite-color-brand);
}
:host([active]) .content .icon {
  --calcite-icon-color: var(--calcite-color-brand);
}

:host([layout=vertical]) .content {
  padding-inline: 0.75rem;
}

.icon--start {
  margin-inline-end: 0.75rem;
}

.icon--end {
  margin-inline-start: 0.75rem;
}

:host([layout=vertical]) .icon--end {
  margin-inline-start: auto;
  padding-inline-start: 0.75rem;
}

.icon--dropdown {
  position: relative;
  margin-inline-start: auto;
  margin-inline-end: 0px;
  padding-inline-start: 0.5rem;
  --calcite-icon-color: var(--calcite-color-text-3);
}

:host([layout=vertical]) .icon--end ~ .icon--dropdown {
  margin-inline-start: 0.75rem;
}

:host([layout=vertical]) .hover-href-icon {
  padding-inline-start: 0.5rem;
}

:host([layout=vertical]) .hover-href-icon ~ .icon--end {
  margin-inline-start: 0.5rem;
}

:host([layout=vertical]) .hover-href-icon ~ .icon--breadcrumb {
  margin-inline-start: 0.75rem;
}

.icon--breadcrumb {
  margin-inline-end: 0px;
  padding-inline-start: 0.5rem;
  --calcite-icon-color: var(--calcite-color-text-3);
}

:host([layout=vertical]) .icon--breadcrumb {
  margin-inline-start: auto;
}

:host([layout=vertical]) .icon--breadcrumb ~ .icon--dropdown {
  margin-inline-start: 0.5rem;
}

:host([layout=vertical]) .icon--end ~ .icon--breadcrumb {
  margin-inline-start: 0.5rem;
}

:host([breadcrumb]) .content {
  padding-inline-end: 0.75rem;
}

calcite-action {
  position: relative;
  block-size: auto;
  border-inline-start: 1px solid var(--calcite-color-foreground-1);
}
calcite-action::after {
  position: absolute;
  inset-inline-start: -1px;
  display: block;
  inline-size: 1px;
  content: "";
  inset-block: 0.75rem;
  background-color: var(--calcite-color-border-3);
}
calcite-action:hover::after {
  block-size: 100%;
  inset-block: 0;
}

.content:focus ~ calcite-action,
.content:hover ~ calcite-action {
  color: var(--calcite-color-text-1);
  border-inline-start: 1px solid var(--calcite-color-border-3);
}

.container:hover .dropdown-action {
  background-color: var(--calcite-color-foreground-2);
}

.dropdown-menu-items {
  position: absolute;
  display: none;
  block-size: auto;
  min-inline-size: 100%;
  flex-direction: column;
  overflow: visible;
  border: 1px solid var(--calcite-color-border-3);
  background: var(--calcite-color-foreground-1);
  inset-block-start: 100%;
  z-index: var(--calcite-z-index-dropdown);
}
.dropdown-menu-items.open {
  display: block;
}
.dropdown-menu-items.nested {
  position: absolute;
  inset-block-start: -1px;
  transform: translateX(calc(100% - 2px));
}

.parent--vertical {
  flex-direction: column;
}

.dropdown--vertical.dropdown-menu-items {
  position: relative;
  border-radius: 0px;
  box-shadow: none;
  inset-block-start: 0;
  transform: none;
}
.dropdown--vertical.dropdown-menu-items:last-of-type {
  border-inline: 0;
}

:host([layout=vertical]:last-of-type) .dropdown-menu-items {
  border-block-end: 0;
}

:host([slot=submenu-item]) .parent--vertical {
  padding-inline-start: 1.5rem;
}

.dropdown-menu-items.nested.calcite--rtl {
  transform: translateX(calc(-100% + 2px));
}

.dropdown--vertical.dropdown-menu-items.nested.calcite--rtl {
  transform: none;
}

.hover-href-icon {
  position: relative;
  inset-inline-end: 0.25rem;
  margin-inline-start: auto;
  opacity: 0;
  transition: all var(--calcite-internal-animation-timing-medium) ease-in-out;
}

.content:focus .hover-href-icon,
.content:hover .hover-href-icon {
  inset-inline-end: -0.25rem;
  opacity: 1;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}